<template>
  <div>
    <el-drawer
      title="组合铺货"
      :visible.sync="visible"
      direction="rtl"
      size="800px"
      @close="handleClose"
    >
      <GroupBulkShelvesContent
        ref="GroupBulkShelvesContentRef"
        :mode="mode"
        :from="from"
        :supplierCompanyId="supplierCompanyId"
        @visibleChange="visibleChange"
        @openPuhuoDialog="openPuhuoDialog"
      ></GroupBulkShelvesContent>
    </el-drawer>
    <PuhuoDialog ref="puhuoDialog" />
  </div>
</template>

<script>
import GroupBulkShelvesContent from './GroupBulkShelvesContent.vue';
import PuhuoDialog from './puhuoDialog.vue';

export default {
  components: {
    GroupBulkShelvesContent,
    PuhuoDialog,
  },
  props: {
    mode: {
      type: String,
      default: '',
    },
    from: String,
    supplierCompanyId: [String, Number],
  },

  data() {
    return {
      visible: false,
    };
  },
  methods: {
    visibleChange(visible) {
      this.visible = visible;
    },
    handleClose() {
      this.$refs.GroupBulkShelvesContentRef.handleClose();
    },
    method_open(data, clearCart, onSuccess) {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.GroupBulkShelvesContentRef.method_open(data, clearCart, onSuccess);
      });
    },
    openPuhuoDialog(params){
      this.$refs.puhuoDialog.method_open(params)
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-drawer.rtl {
  padding: 16px!important;
}
</style>